import { riskColorRangeRedToGreen } from "./risk_colors";
import { riskZoneLineColor, primaryGraphColor, positionDial } from "./globals";
import Highcharts from "highcharts";
import "highcharts/highcharts-more";
import "highcharts/modules/solid-gauge";

const riskGaugeOptions = Object.values(riskColorRangeRedToGreen).map(
  (color) => ({
    y: 10,
    name: "",
    color,
  }),
);

document.addEventListener("turbo:load", () => {
  const charts: NodeListOf<HTMLElement> = document.querySelectorAll(
    "[data-chart='risk_profile']",
  );

  if (charts) {
    Array.from(charts).forEach((chart) => {
      const crpValue = Math.round(parseFloat(chart.dataset.riskProfileCrp!));
      const comparativeCrpValue = Math.round(
        parseFloat(chart.dataset.riskProfileComparativeValue!),
      );

      Highcharts.chart({
        chart: {
          renderTo: chart,
          margin: [0, 0, 0, 0],
          height: 280,
        },
        title: { text: undefined },
        subtitle: { text: undefined },
        pane: {
          borderRadius: 0,
          center: ["50%", "50%"],
          startAngle: -90,
          endAngle: 90,
          size: "85%",
          background: {
            borderWidth: 0,
            backgroundColor: "transparent",
            innerRadius: "90%",
            outerRadius: "100%",
            shape: "arc",
          },
        },
        yAxis: [
          {
            lineWidth: 0,
            min: 0,
            max: 90,
            minorTickLength: 0,
            tickWidth: 0,
            labels: {
              enabled: false,
            },
          },
        ],
        tooltip: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            dataLabels: {
              enabled: false,
            },
            startAngle: -90,
            endAngle: 90,
          },
          gauge: {
            dataLabels: {
              enabled: false,
            },
            pivot: {
              radius: 11,
              borderWidth: 8,
              backgroundColor: riskZoneLineColor,
              borderColor: primaryGraphColor,
            },
            dial: {
              radius: "100%",
              backgroundColor: primaryGraphColor,
              borderColor: primaryGraphColor,
              borderRadius: 0,
              baseWidth: 13,
              baseLength: "5%",
              rearLength: "5%",
              topWidth: 1,
            },
          },
          series: {
            states: {
              inactive: {
                opacity: 1,
              },
              hover: {
                enabled: false,
              },
            },
          },
        },
        series: [
          {
            animation: false,
            type: "pie",
            innerSize: "65%",
            data: riskGaugeOptions,
          },
          {
            animation: false,
            type: "pie",
            size: "68%",
            innerSize: "91%",
            color: "white",
            data: [
              {
                y: 100,
                name: "",
                color: riskZoneLineColor,
              },
            ],
          },
          {
            animation: false,
            type: "gauge",
            data: [positionDial(crpValue)],
            dial: {
              rearLength: "0",
            },
          },
          {
            animation: false,
            type: "gauge",
            visible: !!comparativeCrpValue,
            data: [positionDial(comparativeCrpValue)],
            dial: {
              backgroundColor: "#909090",
              baseWidth: 6,
              borderWidth: 0.5,
              rearLength: "0",
            },
          },
        ],
      });
    });
  }
});
